import { showErrorNotification } from '@shazambanking/sdk/services/notifications';
import { Formik } from 'formik';
import * as React from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import * as yup from 'yup';
import { IAttributesState } from './AttributesState';

import { ATTRIBUTES_URL, EMPTY_STRING, ENROLL_URL } from './Constants';
import { EnrollmentFormWrapper } from './EnrollmentFormWrapper';
import Header from './Header';
import * as UserEnrollmentForm from './UserEnrollmentForm';

interface IState {
  attributes?: IAttributesState;
}

class UserEnrollment extends React.Component<RouteComponentProps<any>, IState> {

  constructor(props: any) {
    super(props);

    this.state = {
      attributes: undefined
    }
  }

  public componentWillMount() {
    fetch(ATTRIBUTES_URL).then(response => response.json()).then(data => this.setState({ attributes: data }));
  }

  public getUserEnrollmentSchema() {
    return yup.object().shape({
      accountNumber: yup
        .string()
        .matches(RegExp('^\\d*$'), 'Account Number must be a numerical value.')
        .matches(RegExp('^\\d{3,11}$'), 'Account Number must be three to eleven digits.')
        .required('Account Number is required.'),
      accountType: yup.string().required('Account Type is required.'),
      email: yup
        .string()
        .email('Invalid email address.')
        .required('Email is required.'),
      ssnLastFour: yup
        .string()
        .matches(RegExp('^\\d{4}$'), 'Last Four of SSN must be four digits.')
        .required('Last Four of SSN is required.'),
      userName: yup
        .string()
        .matches(RegExp('^.{6,15}$'), 'User Name must be 6-15 characters.')
        .matches(RegExp('^[A-Za-z0-9]+$'), 'User Name can only contain letters and numbers.')
        .required('User Name is required.')
    });
  }

  public onReset = async (values: UserEnrollmentForm.IFormValues) => {
    values.accountNumber = EMPTY_STRING;
    values.accountType = EMPTY_STRING;
    values.email = EMPTY_STRING;
    values.ssnLastFour = EMPTY_STRING;
    values.userName = EMPTY_STRING;
  };

  public enroll(values: UserEnrollmentForm.IFormValues) {

    return fetch(ENROLL_URL, {
      body: JSON.stringify({
        accountNumber: values.accountNumber,
        accountType: values.accountType,
        email: values.email,
        ssnLastFour: values.ssnLastFour,
        userName: values.userName
      }),
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'POST'
    });
  }

  public onSubmit = async (values: UserEnrollmentForm.IFormValues) => {
    const doIt = this.enroll(values);

    doIt
      .then(response => {
        const statusCode = response.status;
        const data = response.json();
        return Promise.all([statusCode, data]);
      })
      .then(([statusCode, data]) => {
        switch (statusCode) {
          case 200:
            this.props.history.push({
              pathname: '/confirmation',
              state: {
                companyPhone: this.state.attributes == null ? '' : this.state.attributes.company.companyPhone,
                email: data.email,
                firstName: data.firstName,
                lastName: data.lastName,
                requiresApproval: data.requiresApproval,
                userName: data.userName
              }
            });
            break;
          default:
            showErrorNotification(
              // tslint:disable-next-line: prefer-template
              'Error: ' +
              (data.message !== undefined && data.message !== EMPTY_STRING
                ? data.message
                : statusCode)
            );
        }
      });

    doIt.catch(() => {
      showErrorNotification('Contact Support.');
    });
  };

  public render() {
    const { attributes } = this.state;

    if (attributes == null || !attributes.company.enrollmentEnabled) {
      return (
        <EnrollmentFormWrapper>
          <Header url={attributes == null ? null : attributes.company.companyUrl} />
          <div className="enrollment-panel">
            <p className="enrollment-desc">
              We have not enabled online enrollment. If you believe you have an account or you have been automatically enrolled, please
              &nbsp;<Link to={'/changePassword'}>reset your password.</Link>&nbsp;
              {attributes == null ? '' : 'For help call: ' + attributes.company.companyPhone}
            </p>
          </div>
        </EnrollmentFormWrapper>
      );
}

    return (
      <EnrollmentFormWrapper>
        <Header url={attributes == null ? null : attributes.company.companyUrl} />
        <div className="enrollment-panel">
          <p className="enrollment-desc">
            Enrollment is a two step process. In step one, we will ask for your information to 
            lookup your information and setup a username for you to use. In step two, you will 
            receive an email with a one-time password to setup your account's password. If you 
            have already completed step one,&nbsp;
            <Link to={'/changePassword'}>click here</Link>
            &nbsp;to setup your password.
          </p>
          <p className="enrollment-desc">
            Complete all fields and click Submit. An email address is required for the receipt of
            one-time passwords for user authentication during initial login and password resets. 
            {attributes == null ? '' : 'For help call: ' + attributes.company.companyPhone}
          </p>
          <p className="enrollment-desc">
            Note: In some instances, your Financial Institution may need to approve your enrollment prior to gaining initial access.
          </p>
          <Formik
            initialValues={{
              accountNumber: EMPTY_STRING,
              accountType: EMPTY_STRING,
              email: EMPTY_STRING,
              ssnLastFour: EMPTY_STRING,
              userName: EMPTY_STRING
            }}
            validationSchema={this.getUserEnrollmentSchema}
            onSubmit={this.onSubmit}
            component={UserEnrollmentForm.InlineForm}
          />
        </div>
      </EnrollmentFormWrapper>
    );
  }
}

export default UserEnrollment;



// WEBPACK FOOTER //
// ./src/UserEnrollment.tsx